export default "__VITE_ASSET__cddae945__"